/*
  PDP Klaviyo "Added to Cart" tracking + back-in-stock subscribe — extracted from
  sections/gg-product-pdp.liquid. The Klaviyo company id is the only Liquid-derived value; it
  arrives on this script's own tag so the file stays static and cacheable.

  notifyMeInstock() must remain a global: the back-in-stock forms call it from an inline
  onsubmit attribute, so this file is intentionally not wrapped in an IIFE.
*/
function klaviyoCompanyId() {
  var tag = document.querySelector('script[data-klaviyo-company-id]');
  return tag ? tag.getAttribute('data-klaviyo-company-id') : '';
}

window.addEventListener('load', function() {
  var _learnq = window._learnq || [];
  function addedToCart() {
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      var cart = {
        total_price: data.total_price/100,
        $value: data.total_price/100,
        total_discount: data.total_discount,
        original_total_price: data.original_total_price/100,
        items: data.items
      }
      if (item !== 'undefined') {
        cart = Object.assign(cart, item)
      }
      else {
          _learnq.push(['track', 'Added to Cart', cart]);
        }
    }))
  };
  (function (ns, fetch) {
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        // Only react to a real add-to-cart response. The previous check was inverted —
        // `"<origin>/cart/add.js".includes(res.url)` is true whenever res.url is "" (every
        // string includes ""), so any third-party fetch with an empty response URL fired a
        // spurious /cart.js request.
        if (res && res.url && res.url.indexOf('/cart/add') !== -1) {
            addedToCart()
        }
      });
      return response
    }
  }(window, window.fetch));
  var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
  for (var i = 0; i < atcButtons.length; i++) {
      atcButtons[i].addEventListener("click", function() {
          _learnq.push(['track', 'Added to Cart', item]);
      })
  }
  });

  function notifyMeInstock(form) {
    // make sure required elements are presnt
    if (typeof form != 'object') {
      return false;
    }
    if (typeof form.elements.email != 'object' || form.elements.email.value.length <= 0) {
      return false;
    }
    if (typeof form.elements.variants != 'object' || typeof form.elements.variants[0] != 'object' || form.elements.variants[0].value <= 0) {
      return false;
    }

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": form.elements.email.value,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": "$shopify:::$default:::" + form.elements.variants[0].value
            }
          }
        }
      }
    }
    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2023-12-15"
      },
      body: JSON.stringify(payload),
      variantId: form.elements.variants[0].value
    };
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" + klaviyoCompanyId(), requestOptions)
      .then(result => { 
        if (result.ok == true) {
          if (document.getElementById('notifyme_completed_message_' + requestOptions.variantId)) {
            document.getElementById('notifyme_completed_message_' + requestOptions.variantId).style.display = 'block';
            if (document.getElementById('notifyme_submit_button_' + requestOptions.variantId)) {
              document.getElementById('notifyme_submit_button_' + requestOptions.variantId).style.display = 'none';
            }
          } 
        }
        else if (document.getElementById('notifyme_error_message_' + requestOptions.variantId)) {
          document.getElementById('notifyme_error_message_' + requestOptions.variantId).textContent = 'Something went wrong. Please try again.';
          document.getElementById('notifyme_error_message_' + requestOptions.variantId).style.display = 'block';
        }
      })
      .catch(error => {
        document.getElementById('notifyme_error_message_' + requestOptions.variantId).textContent = 'Something went wrong. Please try again.';
        document.getElementById('notifyme_error_message_' + requestOptions.variantId).style.display = 'block';
        console.log('error', error)
      }
      );
  
    return false;
  }
